import { API_BASE_URL } from "../utils/employeeHelpers";
import { requestJson } from "./instateamEmployeeApi";

function buildQueryString(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, value);
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
}

function authHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
  };
}

export function getEmployeeChatOverview(token, params = {}) {
  return requestJson(`/instateam/chat/employee/overview${buildQueryString(params)}`, {
    headers: authHeaders(token),
  });
}

export function searchEmployeeChatDirectory(token, params = {}) {
  return requestJson(`/instateam/chat/employee/directory${buildQueryString(params)}`, {
    headers: authHeaders(token),
  });
}

export function startEmployeeDirectChat(token, payload) {
  return requestJson("/instateam/chat/employee/direct", {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function createEmployeeGroupChat(token, payload) {
  return requestJson("/instateam/chat/employee/groups", {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function sendEmployeeChatMessage(token, conversationId, formData) {
  return requestJson(`/instateam/chat/employee/conversations/${conversationId}/messages`, {
    method: "POST",
    headers: authHeaders(token),
    body: formData,
  });
}

export function markEmployeeChatRead(token, conversationId) {
  return requestJson(`/instateam/chat/employee/conversations/${conversationId}/read`, {
    method: "POST",
    headers: authHeaders(token),
  });
}

export function toggleEmployeeChatBlock(token, conversationId, blocked) {
  return requestJson(`/instateam/chat/employee/conversations/${conversationId}/block`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ blocked }),
  });
}

export function toggleEmployeeChatMute(token, conversationId, muted) {
  return requestJson(`/instateam/chat/employee/conversations/${conversationId}/mute`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ muted }),
  });
}

export function leaveEmployeeGroupChat(token, conversationId) {
  return requestJson(`/instateam/chat/employee/conversations/${conversationId}/leave`, {
    method: "PATCH",
    headers: authHeaders(token),
  });
}

export function updateEmployeeGroupMembers(token, conversationId, payload) {
  return requestJson(`/instateam/chat/employee/conversations/${conversationId}/members`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function toggleEmployeeMessageReaction(token, messageId, emoji) {
  return requestJson(`/instateam/chat/employee/messages/${messageId}/reaction`, {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ emoji }),
  });
}

export function forwardEmployeeMessage(token, messageId, conversationId) {
  return requestJson(`/instateam/chat/employee/messages/${messageId}/forward`, {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ conversationId }),
  });
}

export function deleteEmployeeMessage(token, messageId, scope) {
  return requestJson(`/instateam/chat/employee/messages/${messageId}/delete`, {
    method: "PATCH",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ scope }),
  });
}

export function getEmployeeSocketClientUrl() {
  return `${API_BASE_URL}/socket.io/socket.io.js`;
}
